import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import './index.scss';
import IconCross from '../../../Icons/IconCross';

const CosignerDocumentModal = ({ onClose, title }) => {
  useEffect(() => {
    document.body.classList.add('body-no-scroll');

    return () => {
      document.body.classList.remove('body-no-scroll');
    };
  }, []);
  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  return ReactDOM.createPortal(
    <div className="cosigner-document-modal-overlay fade-in" onClick={handleBackdropClick}>
      <div
        className="cosigner-document-modal modal-fade-in"
        role="dialog"
        aria-labelledby="dialog-title"
        aria-modal="true"
        onClick={e => e.stopPropagation()}
      >
        <div className="cosigner-document-modal__title">
          <h4 className="cosigner-title">{title}</h4>
          <button
            className="cosigner-document-modal__close"
            title="close"
            aria-label="Close modal"
            type="button"
            onClick={onClose}
          >
            <IconCross />
          </button>
        </div>

        <div className="cosigner-document-modal__content">
          <div className="cosigner-document__title cosigner-document__title--heading">
            Eligibility
          </div>
          <ul className="space-list-item">
            <li>Co-signer can be parent or sibling or spouse</li>

            <li>Co-signer must be 65 or younger to be eligible</li>
          </ul>
          <div className="cosigner-document__title cosigner-document__title--heading spacing">
            Documents Required
          </div>
          <div className="cosigner-document__title">Proof of Identity</div>
          <ul>
            <li>Passport, or Aadhar card, or PAN card, or Driver’s license</li>
          </ul>
          <div className="cosigner-document__title">Proof of Residence</div>
          <ul>
            <li>
              Bank/credit card statement, or Utility bill (electricity, broadband, gas, water, etc),
              or Rental agreement, or Aadhar card
            </li>
          </ul>
          <div className="cosigner-document__title">Proof of Income</div>
          <ul className="space-list-item">
            <li>
              For salaried - Latest 3 months salary slips and bank statement showing the salary
              credited
            </li>
            <li>
              For self-employed - Last 2 year ITR or business/vendor invoices or GST-R and bank
              statements
            </li>
          </ul>
          <div className="cosigner-document__title">Credit bureau report</div>
          <ul>
            <li>Credit report from India with minimum of 650 score</li>
          </ul>
        </div>

        <div className="cosigner-document-modal__footer">
          <button className="cosigner-document-modal__confirm" onClick={onClose}>
            Understood
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default CosignerDocumentModal;
